import keyBy from 'lodash/keyBy';

export const NODE_NAME = 'callout';

export enum CalloutBlockTypeEnum {
  SolidBlack = 'SOLID_BLACK',
  SolidOrange = 'SOLID_ORANGE',
  SolidDarkBlue = 'SOLID_DARK_BLUE',
  SolidLightBlue = 'SOLID_LIGHT_BLUE',
  SolidRed = 'SOLID_RED',
  SolidPurple = 'SOLID_PURPLE',
  SolidOlive = 'SOLID_OLIVE',
  SolidSand = 'SOLID_SAND',
  LightRed = 'LIGHT_RED',
  LightBlue = 'LIGHT_BLUE',
  LightBlack = 'LIGHT_BLACK',
  LightGreen = 'LIGHT_GREEN',
}

export enum CalloutBlockCategory {
  Solid = 'SOLID',
  Light = 'LiIGHT',
}

export const CalloutBlocks = [
  {
    id: CalloutBlockTypeEnum.SolidBlack,
    category: CalloutBlockCategory.Solid,
    background:
      'linear-gradient(91.99deg, #000000 -26.22%, #010101 -14.88%, #020203 -3.54%, #050506 7.8%, #09090B 19.13%, #0E0F11 30.47%, #141518 41.81%, #1A1C20 53.15%, #212329 64.49%, #272A31 75.83%, #2D3038 87.17%, #32363F 98.51%, #363A43 109.85%, #393D47 121.19%, #3A3F49 132.53%, #3B3F49 143.86%)',
  },
  {
    id: CalloutBlockTypeEnum.SolidOrange,
    category: CalloutBlockCategory.Solid,
    background: 'linear-gradient(92.32deg, #F16D50 -0.43%, #F48A4D 100%)',
  },
  {
    id: CalloutBlockTypeEnum.SolidDarkBlue,
    category: CalloutBlockCategory.Solid,
    background: 'linear-gradient(91.87deg, #1338AD 0%, #295DE4 100%)',
  },
  {
    id: CalloutBlockTypeEnum.SolidRed,
    category: CalloutBlockCategory.Solid,
    background: '#D93F4E',
  },
  {
    id: CalloutBlockTypeEnum.SolidPurple,
    category: CalloutBlockCategory.Solid,
    background: '#6357F4',
  },
  {
    id: CalloutBlockTypeEnum.SolidLightBlue,
    category: CalloutBlockCategory.Solid,
    background: '#2D65CB',
  },
  {
    id: CalloutBlockTypeEnum.SolidOlive,
    category: CalloutBlockCategory.Solid,
    background: 'linear-gradient(92deg, #222C0F 0%, #535937 100%)',
    textColor: '#FFFFFF',
  },
  {
    id: CalloutBlockTypeEnum.SolidSand,
    category: CalloutBlockCategory.Solid,
    background: 'linear-gradient(92deg, #F5F3EE 0%, #E9E5D8 100%)',
    textColor: '#222222',
  },
  {
    id: CalloutBlockTypeEnum.LightRed,
    category: CalloutBlockCategory.Light,
    iconColor: '#D93F4E',
    background: '#FDF5F6',
    textColor: '#D93F4E',
  },
  {
    id: CalloutBlockTypeEnum.LightBlue,
    category: CalloutBlockCategory.Light,
    iconColor: '#196DDC',
    background: '#F3F8FD',
    textColor: '#196DDC',
  },
  {
    id: CalloutBlockTypeEnum.LightBlack,
    category: CalloutBlockCategory.Light,
    iconColor: '#222222',
    background: '#F5F5F5',
    textColor: '#222222',
  },
  {
    id: CalloutBlockTypeEnum.LightGreen,
    category: CalloutBlockCategory.Light,
    iconColor: '#1B884C',
    background: '#F4F9F6',
    textColor: '#1B884C',
  },
];

export const calloutBlocksByKey = keyBy(CalloutBlocks, 'id');
